import React, { ReactNode, useCallback } from 'react';
import { Button, Modal } from 'antd';
import { useDispatch } from 'react-redux';
import { toggleBillingModal } from '@redux/actions/modalAction';
import { ContributorsLimitErrorNotificationIcon, CrossIcon } from '@icons';
import './LimitReachedModal.less';

type LimitReachedModalProps = {
  isOpen: boolean;
  title: string;
  text?: string | ReactNode;
  onCancel: () => void;
};

export default function LimitReachedModal({
  isOpen,
  title,
  text,
  onCancel
}: LimitReachedModalProps) {
  const dispatch = useDispatch();

  const onUpgrade = useCallback(() => {
    onCancel();
    dispatch(toggleBillingModal({ visible: true }));
  }, [onCancel, dispatch]);

  return (
    <Modal
      open={isOpen}
      destroyOnClose
      onCancel={onCancel}
      footer={null}
      centered={true}
      width={512}
      zIndex={1010}
      className="limit-reached-modal"
    >
      <CrossIcon className="limit-reached-modal_btn-close" onClick={onCancel} />
      <div className="limit-reached-modal_head">
        <ContributorsLimitErrorNotificationIcon />
        {title}
      </div>
      {text && <div className="limit-reached-modal_text">{text}</div>}
      <div className="limit-reached-modal_buttons">
        <Button type="text" onClick={onCancel}>
          Cancel
        </Button>
        <Button
          type="primary"
          onClick={onUpgrade}
          style={{
            minWidth: 152
          }}
        >
          Upgrade
        </Button>
      </div>
    </Modal>
  );
}
